import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import AccountDeposit from 'AccountDeposit.js';
import AccountWithdraw from 'AccountWithdraw.js';
import S from 'StyledAccountPayments.js';
import {translation} from 'utilsHelper.js';

const AccountPayments = () => {
  const { user } = useSelector((state) => state?.Auth);

  const paymentMethods = [
    { key: 'deposit', label: translation('instantWinGames_deposit_label') },
    { key: 'withdraw', label: translation('instantWinGames_withdraw_label') },
  ];
  const [currentPaymentMethod, setCurrentPaymentMethod] = useState('deposit');

  return (
    <S.AccountPaymentsContainer>
      <S.PaymentsContainer>
        <S.PaymentSwitcher>
          {paymentMethods.map((method) => (
            <S.PaymentSwitch
              key={method.key}
              onClick={() => user && user.balance > 0 && setCurrentPaymentMethod(method.key)}
              className={currentPaymentMethod === method.key ? 'active' : ''}
            >
              {method.label}
            </S.PaymentSwitch>
          ))}
        </S.PaymentSwitcher>
        <S.Payment>
          {currentPaymentMethod === 'deposit' ? <AccountDeposit /> : <AccountWithdraw />}
        </S.Payment>
      </S.PaymentsContainer>
    </S.AccountPaymentsContainer>
  );
};

export default AccountPayments;
